module.exports = __webpack_public_path__ + "static/user1-9b0d2c16cd2aa8000f7157514ea4843b.png";